import { onBeforeUnmount, onMounted } from 'vue'
import { useTheme } from 'vuetify'

const getPropertyValue = (property: string) => {
  return getComputedStyle(document.documentElement).getPropertyValue(property).trim()
}

export function useUpdateVuetifyTheme () {
  const theme = useTheme()
  let observer: MutationObserver | null = null

  const syncPrimaryColor = () => {
    const primaryColor = getPropertyValue('--basic-color')

    if (!primaryColor || !theme.themes.value.light) return

    theme.themes.value.light.colors.primary = primaryColor
  }

  syncPrimaryColor()

  onMounted(() => {
    syncPrimaryColor()

    observer = new MutationObserver(syncPrimaryColor)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style']
    })
  })

  onBeforeUnmount(() => {
    observer?.disconnect()
  })
}
